import { useCurrentUserContext } from "../contexts/CurrentUserContext";

/**
 * Access flags for admin-only features (Tradar, System/Admin).
 * `is_admin` is loaded from the backend database via GET /api/me.
 */
export function useFeatureFlags() {
  const { isAdmin, isLoading } = useCurrentUserContext();

  return {
    // Tradar is retired (Launchpad replaces it): hidden for everyone.
    hasTradarAccess: false,
    isAdmin,
    isLoading,
  };
}
